export default "__VITE_ASSET__M90SJnRG__"